<div class="page-wrapper">
  <div class="content-wrapper margin-top">
    <h2>Admin functions</h2>
    <div class="cards">
      <div class="card" routerLink="/eis/generate-reports">
        <h3>Generate reports</h3>
        <p>
          Generate user reports for a given time period, with custom columns
        </p>
        <button>
          <span>Go to reports</span>
        </button>
      </div>
      <div class="card" routerLink="/eis/users">
        <h3>Manage users</h3>
        <p>
          As an admin you can promote other users to the role of admin so they
          can see this page and perform other admin functions.
        </p>
        <button>
          <span>Go to users</span>
        </button>
      </div>
    </div>
  </div>
</div>
